import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Product } from 'product-shared';
import { Promotion } from 'promotion-shared';
import { ProductCardChipsComponent, ProductCardPriceComponent } from 'sakura-ui';
import { ProductBoxBase } from '../../product-box-base';

@Component({
  selector: 'lib-product-box-pricing',
  templateUrl: './product-box-pricing.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProductCardChipsComponent, ProductCardPriceComponent],
})
export class ProductBoxPricingComponent extends ProductBoxBase {
  public product = input.required<Product>();
  public promotion = input<Promotion>(null);
  public lightMode = input(false);
  public isNavProduct = input(false);
  public hasPromotion = computed(() => !!this.promotion());
}
